export default __webpack_public_path__ + "static/media/blog-img-1.70019b98.jpg";